module.exports = __webpack_public_path__ + "static/media/ab67616d0000b2731fad1bb659f42d22e64ac6fa-394x394.9634ed23.jpg";